import { render, staticRenderFns } from "./r-smart-offer-bundle-decoration.vue?vue&type=template&id=c69d7856"
import script from "./r-smart-offer-bundle-decoration.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-decoration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c69d7856')) {
      api.createRecord('c69d7856', component.options)
    } else {
      api.reload('c69d7856', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-decoration.vue?vue&type=template&id=c69d7856", function () {
      api.rerender('c69d7856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-decoration/r-smart-offer-bundle-decoration.vue"
export default component.exports